import React from "react";
import * as Mui from "@material-ui/core";
import styled from "styled-components";

interface IProps {
    messageText: string;
    messageTitle: string;
    messageType?: string;
    active: boolean;
    handleOnClose: () => void;
    handleConfirm: () => void;
}

export const ConfirmModal: React.FC<IProps> = (props) => {
    const doCloseModal = () => {
        props.handleOnClose();
    };

    const doConfirmation = () => {
        props.handleConfirm();
        //props.handleOnClose();
    };

    return (
        <React.Fragment>
            <Mui.Dialog open={props.active} onClose={doCloseModal}>
                <Mui.DialogTitle className="modalhead">{props.messageTitle}</Mui.DialogTitle>
                <Mui.DialogContent>
                    <Mui.Typography
                        variant="body1"
                        style={{
                            marginTop: "16px",
                        }}
                    >
                        {props.messageText}
                    </Mui.Typography>
                </Mui.DialogContent>

                <Mui.DialogActions>
                    <Mui.Button variant="contained" onClick={() => doConfirmation()}>
                        Confirm
                    </Mui.Button>
                    <Mui.Button variant="contained" onClick={() => doCloseModal()}>
                        Cancel
                    </Mui.Button>
                </Mui.DialogActions>
            </Mui.Dialog>
        </React.Fragment>
    );
};
